import { data } from "jquery";

export function run(){
    var _uploading = false;

    return {
        submitFiles(route) {
            if(_uploading){
                return false;
            }

            _uploading = true;
            $('.invalid-feedback.property_images').html('').addClass('d-none');
            if($('#property_images')[0].files.length <= 0){
                $('.invalid-feedback.property_images').html('Nem adtál meg fájlt').removeClass('d-none');
                return;
            }

            let delay = 0;
            for( var i = 0; i < $('#property_images')[0].files.length; i++ ){
                let file = $('#property_images')[0].files[i];
                if(file.size >= 31457280){
                    swal({
                        title: translate.too_size_image,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: false,
                        padding: '1em',
                        timer: 3000
                    });
                    _uploading = false;
                     return;
                }
            }

            for( var i = 0; i < $('#property_images')[0].files.length; i++ ){
                let formData = new FormData();
                let file = $('#property_images')[0].files[i];

                helper.loader(true);
                formData.append('files', file);
                axios.post( route, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    delay: delay
                }
                ).then(function(response){
                    _uploading = false;
                    helper.loader(false);
                    if(response.data.message == 'fail'){
                        swal({
                            title: response.data.mm,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: false,
                            padding: '1em',
                            timer: 3000
                        });
                    }else{
                        swal({
                            title: response.data.mm,
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            padding: '1em',
                            timer: 3000
                        });
                        $('#documents').append(`
                            <div id="document-${response.data.id}" class="col-12 col-md-3 mb-5" style="position: relative;">
                                <button type="button" class="document-remove btn btn-danger rounded-circle btn-sm" style="position: absolute; right:-5px;top:-15px;" data-id="${response.data.id}" data-route="${response.data.remove_route}"><i class="fa fa-times"></i></button>
                                <img src="${response.data.src}" class="img-fluid"/>
                            </div>
                        `);
                    }
                })
                .catch(function(error){
                    _uploading=false;
                    helper.loader(false);
                });

                delay += 1000;
            }
        },
        jquery(){
            $(document).on('click', '.document-remove', function(){
                formHelper.remove($(this).attr('data-id'), $(this).attr('data-route'), function(response){$(`#document-${response.data.id}`).remove();})
            });
        }
    }
}